import { ProductModel, VariantSKU } from '../types';

export const INITIAL_PRODUCTS: ProductModel[] = [
  {
    id: 'prod-001',
    name: 'Heavyweight Minimal Oversized Tee',
    slug: 'heavyweight-minimal-oversized-tee',
    category: 'Oversized',
    description: 'เสื้อยืดทรงโอเวอร์ไซส์ ผลิตจากผ้า Cotton Comb 100% หนาพิเศษ 240 GSM ทรงสวยอยู่ทรง ไม่ย้วยหลังซัก คอชิดสไตล์เกาหลี สวมใส่สบายระบายอากาศได้ดีเยี่ยม เหมาะกับสภาพอากาศเมืองไทย',
    fabricDetails: '100% Premium Combed Cotton 240 GSM, Rib collar 1.25 inch, Double-needle stitching',
    basePrice: 390,
    isPopular: true,
    colors: [
      {
        name: 'Charcoal Black',
        hex: '#1E1E1E',
        image: 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?w=800&auto=format&fit=crop&q=80',
      },
      {
        name: 'Off-White Ivory',
        hex: '#F4F1EA',
        image: 'https://images.unsplash.com/photo-1581655353564-df123a1eb820?w=800&auto=format&fit=crop&q=80',
      },
      {
        name: 'Forest Green',
        hex: '#233E31',
        image: 'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=800&auto=format&fit=crop&q=80',
      },
      {
        name: 'Vintage Navy',
        hex: '#1E293B',
        image: 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=800&auto=format&fit=crop&q=80',
      },
    ],
    sizes: ['S', 'M', 'L', 'XL', '2XL'],
    sizeChart: {
      S: { chest: 40, length: 27, shoulder: 19, sleeve: 9 },
      M: { chest: 44, length: 28.5, shoulder: 20.5, sleeve: 9.5 },
      L: { chest: 48, length: 29.5, shoulder: 22, sleeve: 10 },
      XL: { chest: 52, length: 30.5, shoulder: 23.5, sleeve: 10.5 },
      '2XL': { chest: 56, length: 31.5, shoulder: 25, sleeve: 11 },
    },
  },
  {
    id: 'prod-002',
    name: 'Tokyo Vintage Washed Graphic Tee',
    slug: 'tokyo-vintage-washed-graphic-tee',
    category: 'Vintage',
    description: 'เสื้อยืดลายกราฟิกแนววินเทจ ผ่านกระบวนการฟอกสีแบบ Enzyme Wash ให้สัมผัสนุ่มและมีเท็กซ์เจอร์เฉพาะตัว สกรีนลายแบบซึมลงเนื้อผ้า ระบายเหงื่อได้ดี ไม่เหนียวตัว',
    fabricDetails: '100% Washed Cotton 210 GSM, Soft touch, Distressed finish',
    basePrice: 450,
    isPopular: true,
    colors: [
      {
        name: 'Washed Black',
        hex: '#2B2B2B',
        image: 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=800&auto=format&fit=crop&q=80',
      },
      {
        name: 'Vintage Beige',
        hex: '#D7C4B7',
        image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?w=800&auto=format&fit=crop&q=80',
      },
      {
        name: 'Faded Terracotta',
        hex: '#A05844',
        image: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=800&auto=format&fit=crop&q=80',
      },
    ],
    sizes: ['S', 'M', 'L', 'XL'],
    sizeChart: {
      S: { chest: 38, length: 26.5, shoulder: 18, sleeve: 8.5 },
      M: { chest: 42, length: 27.5, shoulder: 19.5, sleeve: 9 },
      L: { chest: 46, length: 28.5, shoulder: 21, sleeve: 9.5 },
      XL: { chest: 50, length: 29.5, shoulder: 22.5, sleeve: 10 },
      '2XL': { chest: 54, length: 30.5, shoulder: 24, sleeve: 10.5 },
    },
  },
  {
    id: 'prod-003',
    name: 'AirFlex Pro-Breathable Sport Tee',
    slug: 'airflex-pro-breathable-sport-tee',
    category: 'Sport',
    description: 'เสื้อออกกำลังกายและวิ่ง นวัตกรรมเนื้อผ้า Micro-Pique น้ำหนักเบาพิเศษ แห้งไวกว่าผ้าทั่วไปถึง 3 เท่า พร้อมเทคโนโลยีต้านการสะสมของแบคทีเรียและกลิ่นอับ ยืดหยุ่น 4 ทิศทาง',
    fabricDetails: '88% Polyester, 12% Spandex Quick-Dry Mesh 160 GSM, Anti-Odor treated',
    basePrice: 350,
    colors: [
      {
        name: 'Slate Grey',
        hex: '#5B6770',
        image: 'https://images.unsplash.com/photo-1581655353564-df123a1eb820?w=800&auto=format&fit=crop&q=80',
      },
      {
        name: 'Midnight Blue',
        hex: '#162238',
        image: 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?w=800&auto=format&fit=crop&q=80',
      },
      {
        name: 'Neon Lime',
        hex: '#32CD32',
        image: 'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=800&auto=format&fit=crop&q=80',
      },
    ],
    sizes: ['M', 'L', 'XL', '2XL'],
    sizeChart: {
      S: { chest: 37, length: 26, shoulder: 17, sleeve: 8 },
      M: { chest: 40, length: 27, shoulder: 18, sleeve: 8.5 },
      L: { chest: 43, length: 28, shoulder: 19, sleeve: 9 },
      XL: { chest: 46, length: 29, shoulder: 20, sleeve: 9.5 },
      '2XL': { chest: 49, length: 30, shoulder: 21, sleeve: 10 },
    },
  },
  {
    id: 'prod-004',
    name: 'Everyday Classic Regular-Fit Crewneck',
    slug: 'everyday-classic-regular-fit-crewneck',
    category: 'Basic',
    description: 'เสื้อยืดเบสิกทรงมาตรฐานที่ทุกคนต้องมีติดตู้ ผลิตจากเส้นใยฝ้ายธรรมชาติ 100% สวมใส่ได้ทุกวัน แมตช์ง่ายกับกางเกงทุกแบบ คอเสื้อทอแน่นพิเศษ ไม่ย้วยง่าย',
    fabricDetails: '100% Ring Spun Cotton 190 GSM, Pre-shrunk fabric',
    basePrice: 290,
    colors: [
      {
        name: 'Pure White',
        hex: '#FFFFFF',
        image: 'https://images.unsplash.com/photo-1581655353564-df123a1eb820?w=800&auto=format&fit=crop&q=80',
      },
      {
        name: 'Classic Black',
        hex: '#111111',
        image: 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?w=800&auto=format&fit=crop&q=80',
      },
      {
        name: 'Heather Grey',
        hex: '#9E9E9E',
        image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?w=800&auto=format&fit=crop&q=80',
      },
    ],
    sizes: ['S', 'M', 'L', 'XL'],
    sizeChart: {
      S: { chest: 36, length: 26, shoulder: 16.5, sleeve: 8 },
      M: { chest: 40, length: 27.5, shoulder: 18, sleeve: 8.5 },
      L: { chest: 44, length: 28.5, shoulder: 19.5, sleeve: 9 },
      XL: { chest: 48, length: 29.5, shoulder: 21, sleeve: 9.5 },
      '2XL': { chest: 52, length: 30.5, shoulder: 22.5, sleeve: 10 },
    },
  },
];

// สร้างรายการ SKU สำหรับสินค้าทั้งหมด
export const INITIAL_SKUS: VariantSKU[] = [
  // Product 001 - Heavyweight Minimal Oversized Tee
  { id: 'sku-01-blk-s', productModelId: 'prod-001', skuCode: 'TS-OVR-BLK-S', colorName: 'Charcoal Black', sizeCode: 'S', physicalStock: 12, reservedStock: 0 },
  { id: 'sku-01-blk-m', productModelId: 'prod-001', skuCode: 'TS-OVR-BLK-M', colorName: 'Charcoal Black', sizeCode: 'M', physicalStock: 25, reservedStock: 0 },
  { id: 'sku-01-blk-l', productModelId: 'prod-001', skuCode: 'TS-OVR-BLK-L', colorName: 'Charcoal Black', sizeCode: 'L', physicalStock: 30, reservedStock: 0 },
  { id: 'sku-01-blk-xl', productModelId: 'prod-001', skuCode: 'TS-OVR-BLK-XL', colorName: 'Charcoal Black', sizeCode: 'XL', physicalStock: 18, reservedStock: 0 },
  { id: 'sku-01-blk-2xl', productModelId: 'prod-001', skuCode: 'TS-OVR-BLK-2XL', colorName: 'Charcoal Black', sizeCode: '2XL', physicalStock: 5, reservedStock: 0 },

  { id: 'sku-01-wht-s', productModelId: 'prod-001', skuCode: 'TS-OVR-WHT-S', colorName: 'Off-White Ivory', sizeCode: 'S', physicalStock: 15, reservedStock: 0 },
  { id: 'sku-01-wht-m', productModelId: 'prod-001', skuCode: 'TS-OVR-WHT-M', colorName: 'Off-White Ivory', sizeCode: 'M', physicalStock: 20, reservedStock: 0 },
  { id: 'sku-01-wht-l', productModelId: 'prod-001', skuCode: 'TS-OVR-WHT-L', colorName: 'Off-White Ivory', sizeCode: 'L', physicalStock: 22, reservedStock: 0 },
  { id: 'sku-01-wht-xl', productModelId: 'prod-001', skuCode: 'TS-OVR-WHT-XL', colorName: 'Off-White Ivory', sizeCode: 'XL', physicalStock: 10, reservedStock: 0 },
  { id: 'sku-01-wht-2xl', productModelId: 'prod-001', skuCode: 'TS-OVR-WHT-2XL', colorName: 'Off-White Ivory', sizeCode: '2XL', physicalStock: 0, reservedStock: 0 }, // Out of stock demo!

  { id: 'sku-01-grn-m', productModelId: 'prod-001', skuCode: 'TS-OVR-GRN-M', colorName: 'Forest Green', sizeCode: 'M', physicalStock: 14, reservedStock: 0 },
  { id: 'sku-01-grn-l', productModelId: 'prod-001', skuCode: 'TS-OVR-GRN-L', colorName: 'Forest Green', sizeCode: 'L', physicalStock: 16, reservedStock: 0 },
  { id: 'sku-01-nvy-l', productModelId: 'prod-001', skuCode: 'TS-OVR-NVY-L', colorName: 'Vintage Navy', sizeCode: 'L', physicalStock: 20, reservedStock: 0 },

  // Product 002 - Tokyo Vintage Graphic Tee
  { id: 'sku-02-blk-m', productModelId: 'prod-002', skuCode: 'TS-VNT-BLK-M', colorName: 'Washed Black', sizeCode: 'M', physicalStock: 10, reservedStock: 0 },
  { id: 'sku-02-blk-l', productModelId: 'prod-002', skuCode: 'TS-VNT-BLK-L', colorName: 'Washed Black', sizeCode: 'L', physicalStock: 15, reservedStock: 0 },
  { id: 'sku-02-bge-l', productModelId: 'prod-002', skuCode: 'TS-VNT-BGE-L', colorName: 'Vintage Beige', sizeCode: 'L', physicalStock: 8, reservedStock: 0 },

  // Product 003 - AirFlex Sport Tee
  { id: 'sku-03-gry-m', productModelId: 'prod-003', skuCode: 'TS-SPT-GRY-M', colorName: 'Slate Grey', sizeCode: 'M', physicalStock: 15, reservedStock: 0 },
  { id: 'sku-03-gry-l', productModelId: 'prod-003', skuCode: 'TS-SPT-GRY-L', colorName: 'Slate Grey', sizeCode: 'L', physicalStock: 20, reservedStock: 0 },
  { id: 'sku-03-nvy-l', productModelId: 'prod-003', skuCode: 'TS-SPT-NVY-L', colorName: 'Midnight Blue', sizeCode: 'L', physicalStock: 12, reservedStock: 0 },

  // Product 004 - Everyday Classic Crewneck
  { id: 'sku-04-wht-m', productModelId: 'prod-004', skuCode: 'TS-BSC-WHT-M', colorName: 'Pure White', sizeCode: 'M', physicalStock: 40, reservedStock: 0 },
  { id: 'sku-04-wht-l', productModelId: 'prod-004', skuCode: 'TS-BSC-WHT-L', colorName: 'Pure White', sizeCode: 'L', physicalStock: 35, reservedStock: 0 },
  { id: 'sku-04-blk-l', productModelId: 'prod-004', skuCode: 'TS-BSC-BLK-L', colorName: 'Classic Black', sizeCode: 'L', physicalStock: 30, reservedStock: 0 },
];
